export function formatDate(date) {
  var d = new Date(date);

  var month = "" + d.getMonth();
  // var month = '' + (d.getMonth())
  var day = "" + d.getDate();
  var year = d.getFullYear();

  if (month.length < 2) month = "0" + month;

  switch (month) {
    case "00":
      month = "10";
      year = year - 1;
      break;
    case "01":
      month = "11";
      year = year - 1;
      break;
    case "02":
      month = "12";
      year = year - 1;
      break;
    case "03":
      month = "01";
      break;
    case "04":
      month = "02";
      break;
    case "05":
      month = "03";
      break;
    case "06":
      month = "04";
      break;
    case "07":
      month = "05";
      break;
    case "08":
      month = "06";
      break;
    case "09":
      month = "07";
      break;
    case "10":
      month = "08";
      break;
    case "11":
      month = "09";
      break;

    default:
      break;
  }

  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

//credits go to ChatGPT ❤️‍🔥
export function getPreviousAndWeekLaterDates() {
  // Define a new Date object for the current moment
  const currentDate = new Date();

  // Define a new Date object for yesterday by subtracting one day from the current date
  const yesterday = new Date();
  yesterday.setDate(currentDate.getDate() - 1);

  // Define a new Date object for a week later by adding seven days to the current date
  const weekLater = new Date();
  weekLater.setDate(currentDate.getDate() + 7);

  // Print the results to the console
  // console.log("Yesterday:", yesterday.toLocaleDateString());
  // console.log("Week Later:", weekLater.toLocaleDateString());

  return { yesterday, weekLater, currentDate };
}
